<template>
    <biller-modal :isVisible="shouldShow" @close="$emit('close')">
        <div class="pt-24 px-16 md:px-24 pb-12 text-center modal-width">
            <p class="text-grey-300 text-base font-semibold">Awaiting confirmation</p>
            <div class="my-12 relative h-48 flex items-center justify-center">
                <svg width="232" height="144" viewBox="0 0 232 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M202.135 113.722C201.513 91.1134 192.097 70.5359 177.063 55.4986H177.061C161.047 39.488 139.385 30.3877 116.441 30.3877C94.1992 30.3877 72.301 39.0172 55.8196 55.4986C39.7702 71.5498 31.3382 92.524 30.7475 113.728C30.7157 114.867 29.7724 115.769 28.6333 115.769H204.248C203.107 115.768 202.167 114.863 202.135 113.722Z"
                        fill="#E4EAF8"
                    />
                    <path
                        d="M71.6327 56.4649C86.1763 41.3606 104.939 32.6112 124.433 30.7632C121.791 30.5164 119.125 30.3877 116.441 30.3877C94.1992 30.3877 72.301 39.0172 55.8196 55.4968C39.7702 71.5498 31.3382 92.5223 30.7475 113.726C30.7157 114.865 29.7724 115.768 28.6333 115.768H46.6029C47.4564 94.1462 55.8672 72.8405 71.6327 56.4649Z"
                        fill="#D8DCE5"
                    />
                    <path
                        d="M198.173 34.3798C176.442 12.6579 147.188 0.52301 116.441 0.52301V31.9571C138.964 31.9571 160.227 40.8899 175.947 56.606L198.173 34.3798Z"
                        fill="#FECA57"
                    />
                    <path
                        d="M34.7078 34.3781L56.9357 56.606C72.7418 40.7999 94.0546 31.9571 116.441 31.9571V0.52301C87.3259 0.52301 59.0146 10.9405 34.7078 34.3781Z"
                        fill="#15BA8B"
                    />
                    <path
                        d="M34.7078 34.3781L56.9357 56.606C72.7418 40.7999 94.0546 31.9571 116.441 31.9571V0.52301C87.3259 0.52301 59.0146 10.9405 34.7078 34.3781Z"
                        fill="#15BA8B"
                    />
                    <path
                        d="M0.882924 113.632C0.858238 114.801 1.79278 115.768 2.96184 115.768H30.2486C31.3666 115.768 32.2923 114.882 32.324 113.765C32.9024 92.949 41.181 72.3626 56.9359 56.6059L34.708 34.378C13.8131 55.2729 1.523 83.4555 0.882924 113.632Z"
                        fill="#54A0FF"
                    />
                    <path
                        d="M49.0256 33.4964C68.7162 14.5094 91.0094 3.98258 114.235 0.547699C85.8977 1.06258 58.401 11.533 34.7078 34.3781L41.7768 41.4471C44.0637 38.6981 46.4812 36.0426 49.0256 33.4964Z"
                        fill="#11AA7B"
                    />
                    <path
                        d="M16.9376 115.768C15.7545 115.768 14.8093 114.791 14.8358 113.609C15.4036 86.781 25.0858 61.5167 41.777 41.447L34.708 34.378C13.8131 55.2729 1.523 83.4555 0.882924 113.632C0.858238 114.801 1.79278 115.768 2.96184 115.768H30.2487H16.9376Z"
                        fill="#338DEF"
                    />
                    <path
                        d="M198.174 34.378L175.947 56.6059C190.707 71.3682 199.948 91.5666 200.558 113.761C200.59 114.881 201.514 115.768 202.634 115.768H229.921C231.09 115.768 232.024 114.803 232 113.632C231.37 84.1978 219.563 55.7596 198.174 34.378Z"
                        fill="#F46036"
                    />
                    <path
                        d="M150.413 119.807L167.294 65.1842C167.993 62.9219 165.873 60.8025 163.613 61.5007L108.988 78.3824C85.1589 85.7476 77.7125 115.812 95.3489 133.446C112.985 151.083 143.047 143.636 150.413 119.807Z"
                        fill="#F67C5A"
                    />
                    <path
                        d="M109.3 133.446C91.6636 115.812 99.1117 85.7477 122.941 78.3824L167.404 64.6412C167.644 62.5993 165.692 60.8589 163.613 61.5007L108.988 78.3824C85.1589 85.7477 77.7125 115.812 95.3489 133.446C103.871 141.968 115.293 144.633 125.654 142.423C119.758 141.154 114.073 138.221 109.3 133.446Z"
                        fill="#F46036"
                    />
                    <path
                        d="M128.393 100.4C122.844 94.8497 113.846 94.8497 108.295 100.4C102.746 105.95 102.746 114.948 108.295 120.498C113.846 126.047 122.844 126.047 128.393 120.498C133.943 114.948 133.943 105.95 128.393 100.4Z"
                        fill="#EE5253"
                    />
                    <path
                        d="M125.452 98.1399C120.017 94.9978 112.948 95.7507 108.297 100.4C102.748 105.95 102.748 114.949 108.297 120.498C112.946 125.148 120.017 125.899 125.452 122.759C115.949 117.265 116.027 103.59 125.452 98.1399Z"
                        fill="#F46036"
                    />
                </svg>
            </div>
            <div class="flex items-center mt-3" v-show="no_of_times_clicked > 3">
                <svg
                    width="80"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    class="mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8 5.6C7.5584 5.6 7.2 5.2416 7.2 4.8C7.2 4.3584 7.5584 4 8 4C8.4416 4 8.8 4.3584 8.8 4.8C8.8 5.2416 8.4416 5.6 8 5.6ZM8.8 11.2C8.8 11.6416 8.4416 12 8 12C7.5584 12 7.2 11.6416 7.2 11.2V7.2C7.2 6.7584 7.5584 6.4 8 6.4C8.4416 6.4 8.8 6.7584 8.8 7.2V11.2ZM8 0C3.5816 0 0 3.5816 0 8C0 12.4184 3.5816 16 8 16C12.4176 16 16 12.4184 16 8C16 3.5816 12.4176 0 8 0Z"
                        fill="#9DA8B6"
                    />
                </svg>
                <p class="text-xs text-smoke-dark">
                    if you have already made payment, please wait a for about 5 mins before validating payament again.
                    If you have not made payment, please make payment before clicking the validate button again
                </p>
            </div>
            <div class="flex items-center justify-center pt-10">
                <button
                    @click="proceedValidation"
                    class="rounded-lg bg-orange-pale px-8 py-4 text-orange font-semibold text-base"
                >
                    Validate Again
                </button>
            </div>
        </div>
    </biller-modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: {
        shouldShow: {
            type: Boolean,
            default: true,
        },
        reference: {
            type: String,
            default: '',
            required: true,
        },
    },

    data() {
        return {
            no_of_times_clicked: 0,
        }
    },

    methods: {
        ...mapActions('Transaction', {
            validatePayment: 'FETCH_TRANSACTION_DETAILS',
        }),

        proceedValidation() {
            this.no_of_times_clicked = this.no_of_times_clicked += 1
            this.validatePayment(this.reference)
        },
    },
}
</script>

<style scoped>
@keyframes spinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.spin {
    animation: 1.5s linear infinite spinner;
    animation-play-state: inherit;
}
@media screen and (min-width: 640px) {
    .modal-width {
        width: 450px;
    }
}
</style>
